import React, { useEffect, useRef, useState, useId } from "react"
import cx from 'classnames'
import { withOrientationChange } from 'react-device-detect'
import carret from '@/public/icons/arrow-up.svg'

const Sort = ({ texts, data, page, selectedtab, tabIndex = 0, isSearch, selectedSort, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const sortId = useId();
    const sortClass = cx({ 'sort': true, 'sort--open': isOpen })
    const sortBtn = useRef(null)
    const pastServiceMenu = useRef(null)
    const sortByWrapper = useRef(null)

    const getAnalyticsData = (item, needJson = false) => {
        let analyticsData = '';
        if (page === 'search') {
            analyticsData = {
                eventAction: `search results:${selectedtab}:main content area:sort by`,
                eventName: `search results:${selectedtab}:main content area:sort by`,
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: item.name,
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: `search results:${selectedtab}:main content area`,
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'technicalspecs') {
            analyticsData = {
                eventAction: "technical specs:main content area:sort by",
                eventName: "technical specs:main content area:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs:sort by",
                internalLinkZoneName: "technical specs:main content area​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'favorites') {
            analyticsData = {
                eventAction: `my account:favorites:${selectedtab}:sort by`,
                eventName: `my account:favorites:${selectedtab}:sort by`,
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "favorites",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: `my account:favorites:${selectedtab}`,
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'article') {
            analyticsData = {
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'active-services') {
            analyticsData = {
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'past-services') {
            analyticsData = {
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'literature') {
            analyticsData = {
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'press-release') {
            analyticsData = {
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'press-kits') {
            analyticsData = {
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else if (page === 'my products') {
            analyticsData = {
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        } else {
            analyticsData = {
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: `${item.name}`,
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
              }
        }
        if(needJson) return analyticsData
        return JSON.stringify(analyticsData);
    }
    useEffect(() => {
        const closeOnOutsideClick = event => {
            if (!sortByWrapper.current?.contains(event.target)) setIsOpen(false);
        };
        window.addEventListener("click", closeOnOutsideClick);
        return () => window.removeEventListener("click", closeOnOutsideClick);
    }, []);

    useEffect(() => {
        if (isOpen) pastServiceMenu.current?.children[activeIndex]?.focus();
    }, [isOpen, activeIndex]);

    const openOptions = () => {
        setActiveIndex(Math.max(0, data.findIndex(item => item.name === selectedSort?.name)));
        setIsOpen(true);
    };
    const closeOptions = () => {
        setIsOpen(false);
        sortBtn.current?.focus();
    };
    const btnKeyDown = event => {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            openOptions();
        }
    };
    const handleKeyDown = (index, event) => {
        switch (event.key) {
            case "Escape":
                event.preventDefault();
                closeOptions();
                break;
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                setActiveIndex((index + (event.key === "ArrowDown" ? 1 : -1) + data.length) % data.length);
                break;
            case "Home":
            case "End":
                event.preventDefault();
                setActiveIndex(event.key === "Home" ? 0 : data.length - 1);
                break;
            case " ":
            case "Enter":
                event.preventDefault();
                event.currentTarget.click();
                break;
            case "Tab":
                setIsOpen(false);
                break;
            default:
                break;
        }
    };


    return (
        <div className={sortClass} ref={sortByWrapper} >
            <button ref={sortBtn} 
                className="sort__toggle" 
                tabIndex={tabIndex} 
                id={`${sortId}-label`}
                type="button"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                aria-controls={`${sortId}-options`}
                onClick={() => isOpen ? setIsOpen(false) : openOptions()}
                onKeyDown={btnKeyDown}>
               {`${texts.sort} ${selectedSort ? ': '+selectedSort.name : 'Featured'}`}
                <img src={carret?.src} alt="" 
                    className="sort__toggle-icon" 
                    aria-hidden="true" 
                />
            </button>
            <ul
                ref={pastServiceMenu}
                id={`${sortId}-options`}
                hidden={!isOpen}
                className="sort__drop-down"
                role="listbox"
                aria-labelledby={`${sortId}-label`}
            >
                {
                    data.map((item, i) => {
                        return (<li 
                            key={i}
                            id={`${sortId}-option-${i}`}
                            role="option"
                            tabIndex={isOpen && activeIndex === i ? 0 : -1}
                            onFocus={() => setActiveIndex(i)}
                            aria-selected={item?.name === selectedSort?.name} 
                            className={`sort__item gbh-data-layer ${(item && item.name) === (selectedSort && selectedSort?.name) ? 'active' : ""}`} 
                            data-gbh-data-layer={getAnalyticsData(item)}
                            onClick={() => {onChange(item);closeOptions()}}
                            onKeyDown={(e) => handleKeyDown(i, e)}
                            >
                            {item.name}
                        </li>);
                    })
                }
            </ul>
        </div>
    )
}

export default withOrientationChange(Sort);
